import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz-trans/client';

import Link from '../Link';

import TrustpilotLogo from './TrustpilotLogo';
import TrustpilotStars from './TrustpilotStars';

import styles from './TrustpilotReviews.module.scss';

const TrustPilotLink = ({ onClick, children }) => (
  <Link
    theme="dark"
    target="_blank"
    rel="noopener noreferrer"
    href="https://www.trustpilot.com/review/www.spotahome.com"
    onClick={onClick}
    underlined={false}
  >
    {children}
  </Link>
);

TrustPilotLink.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired
};

const TrustPilotContent = ({ theme, className, scoreNumber, hideScore }) => {
  const trustpilotClasses = classNames(styles['trustpilot-reviews'], className);
  const trustpilotInfoClasses = classNames(styles['trustpilot-reviews__info'], {
    [styles['trustpilot-reviews__info--light']]: theme === 'light',
    [styles['trustpilot-reviews__info--dark']]: theme === 'dark',
    [styles['trustpilot-reviews__info--minimal']]: theme === 'minimal'
  });
  const trustpilotLogoClasses = classNames(styles['trustpilot-reviews__logo'], {
    [styles['trustpilot-reviews__logo--minimal']]: theme === 'minimal'
  });
  const trustpilotStarClasses = classNames(
    styles['trustpilot-reviews__stars'],
    {
      [styles['trustpilot-reviews__stars--minimal']]: theme === 'minimal'
    }
  );
  const isMinimal = theme === 'minimal';

  return (
    <div className={trustpilotClasses}>
      <div className={trustpilotLogoClasses}>
        <TrustpilotLogo theme={theme} />
      </div>

      <div className={trustpilotStarClasses}>
        <TrustpilotStars theme={theme} />
      </div>

      <div className={trustpilotInfoClasses}>
        {!hideScore ? `${scoreNumber.toFixed(1)} ` : null}
        {!isMinimal ? `(7650+ ${trans('trustpilot.reviews.total')})` : null}
      </div>
    </div>
  );
};

TrustPilotContent.propTypes = {
  theme: PropTypes.oneOf(['dark', 'light', 'minimal']),
  className: PropTypes.string,
  scoreNumber: PropTypes.number,
  hideScore: PropTypes.bool
};

TrustPilotContent.defaultProps = {
  theme: 'dark',
  className: null,
  scoreNumber: 4.1,
  hideScore: false
};

const TrustpilotReviews = ({ isExternalLink, onLinkClick, ...props }) =>
  isExternalLink ? (
    <TrustPilotLink onClick={onLinkClick}>
      <TrustPilotContent {...props} />
    </TrustPilotLink>
  ) : (
    <TrustPilotContent {...props} />
  );

TrustpilotReviews.propTypes = {
  isExternalLink: PropTypes.bool,
  onLinkClick: PropTypes.func
};

TrustpilotReviews.defaultProps = {
  isExternalLink: true,
  onLinkClick: () => {}
};

export default TrustpilotReviews;
